"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
require("./datatables");
require("./cards/client_login_card");
require("./cards/client_portal_card");
require("./cards/staff_login_card");
require("./cards/staff_portal_card");
const api_1 = __importDefault(require("./api"));
const common_1 = require("./common");
const types_1 = require("../types");
(0, web_ui_1.$)(document).ready(() => {
    (0, web_ui_1.$)('#client-portal-card, #staff-login-card, #staff-portal-card').hide()
        .removeClass('d-none');
    (0, web_ui_1.$)('.current_year').text((new Date()).getFullYear())
        .val((new Date()).getFullYear());
    for (const [value, name] of types_1.FileTypes) {
        (0, web_ui_1.createElement)('option')
            .attr('value', value)
            .text(name)
            .appendTo((0, web_ui_1.$)('#edit_client_type'));
    }
    (0, web_ui_1.$)('#staff_button').on('click', () => {
        (0, common_1.swapCard)((0, web_ui_1.$)('#client-login-card'), (0, web_ui_1.$)('#staff-login-card'), (0, web_ui_1.$)('#client_button'));
    });
    (0, web_ui_1.$)('#client_button').on('click', () => {
        (0, common_1.swapCard)((0, web_ui_1.$)('#staff-login-card'), (0, web_ui_1.$)('#client-login-card'), (0, web_ui_1.$)('#client_dob'));
    });
    (0, web_ui_1.$)('#staff_logout_button, #client_logout_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        yield (0, common_1.logout)();
    }));
    const timer = new web_ui_1.Timer(10000, true);
    timer.on('tick', () => __awaiter(void 0, void 0, void 0, function* () {
        if (api_1.default.isLoggedIn) {
            try {
                if (!(yield api_1.default.ping())) {
                    yield (0, common_1.logout)();
                }
            }
            catch (_a) { }
        }
    }));
});
